"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _ProductDetailSpagetty = _interopRequireDefault(require("@sprinx/react-com/ProductDetailSpagetty"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _withChildrenIfStaticBuild = _interopRequireDefault(require("../../../withChildrenIfStaticBuild"));

var _ProductDetailSpagettyNavigation = _interopRequireDefault(require("./ProductDetailSpagettyNavigation"));

var _ProductDetailSpagettyItemLongDescription = _interopRequireDefault(require("./ProductDetailSpagettyItemLongDescription"));

var _ProductDetailSpagettyItemPackage = _interopRequireDefault(require("./ProductDetailSpagettyItemPackage"));

var _ProductDetailSpagettyItemParameters = _interopRequireDefault(require("./ProductDetailSpagettyItemParameters"));

var _ProductDetailSpagettyItemFotoAndVideo = _interopRequireDefault(require("./ProductDetailSpagettyItemFotoAndVideo"));

var _ProductDetailSpagettyItemAlternatives = _interopRequireDefault(require("./ProductDetailSpagettyItemAlternatives"));

var _ProductDetailSpagettyItemQuestions = _interopRequireDefault(require("./ProductDetailSpagettyItemQuestions"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      marginTop: theme.spacing(2)
    },
    fixedMenu: {
      top: 0
    },
    title: (0, _defineProperty2.default)({
      fontSize: 28,
      textTransform: 'none',
      fontWeight: 300
    }, theme.breakpoints.down('sm'), {
      fontSize: 20,
      fontWeight: 400
    }),
    titleSection: (0, _defineProperty2.default)({
      marginRight: theme.spacing(1),
      textTransform: theme.text.textTransformUppercase,
      fontWeight: 400
    }, theme.breakpoints.down('sm'), {
      fontSize: 16
    })
  };
}, {
  name: 'ProductDetailSpagetty'
});

function ProductDetailSpagetty(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      renderToGridArea = _ref.renderToGridArea,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "product", "renderToGridArea"]);
  var classes = useStyles({
    classes: pClasses
  });

  var refEl = _react.default.useRef(null);

  var theme = (0, _styles.useTheme)();
  var collapsable = (0, _useMediaQuery.default)(theme.breakpoints.down('sm'));

  var alternativesRef = _react.default.useRef(null);

  return /*#__PURE__*/_react.default.createElement(_ProductDetailSpagetty.default, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className),
    classes: {
      fixedMenu: classes.fixedMenu
    },
    renderNavigation: function renderNavigation(props) {
      return !collapsable && /*#__PURE__*/_react.default.createElement(_ProductDetailSpagettyNavigation.default, (0, _extends2.default)({}, props, {
        ref: refEl
      }));
    }
  }), /*#__PURE__*/_react.default.createElement(_ProductDetailSpagettyItemLongDescription.default, {
    product: product,
    collapsable: collapsable,
    classes: {
      title: classes.title,
      titleSection: classes.titleSection
    },
    noActiveZone: collapsable
  }), /*#__PURE__*/_react.default.createElement(_ProductDetailSpagettyItemParameters.default, {
    product: product,
    collapsable: collapsable,
    classes: {
      title: classes.title,
      titleSection: classes.titleSection
    },
    noActiveZone: collapsable
  }), /*#__PURE__*/_react.default.createElement(_ProductDetailSpagettyItemPackage.default, {
    product: product,
    collapsable: collapsable,
    classes: {
      title: classes.title,
      titleSection: classes.titleSection
    },
    noActiveZone: collapsable
  }), /*#__PURE__*/_react.default.createElement(_ProductDetailSpagettyItemFotoAndVideo.default, {
    product: product,
    collapsable: collapsable,
    classes: {
      title: classes.title,
      titleSection: classes.titleSection
    },
    noActiveZone: collapsable
  }), /*#__PURE__*/_react.default.createElement(_ProductDetailSpagettyItemAlternatives.default, {
    product: product,
    collapsable: collapsable,
    classes: {
      title: classes.title,
      titleSection: classes.titleSection
    },
    ref: alternativesRef,
    noActiveZone: collapsable
  }), /*#__PURE__*/_react.default.createElement(_ProductDetailSpagettyItemQuestions.default, {
    product: product,
    collapsable: collapsable,
    classes: {
      title: classes.title,
      titleSection: classes.titleSection
    },
    noActiveZone: collapsable
  }));
}

process.env.NODE_ENV !== "production" ? ProductDetailSpagetty.propTypes = {
  classes: _propTypes.default.shape({
    fixedMenu: _propTypes.default.string,
    root: _propTypes.default.string,
    title: _propTypes.default.string,
    titleSection: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  product: _propTypes.default.shape({
    name: _propTypes.default.arrayOf(_propTypes.default.shape({
      language: _propTypes.default.string,
      text: _propTypes.default.string
    }))
  }),
  renderToGridArea: _propTypes.default.string
} : void 0;
ProductDetailSpagetty.defaultProps = {
  classes: undefined,
  className: undefined,
  product: undefined,
  renderToGridArea: 'parameters'
};

var _default = (0, _withChildrenIfStaticBuild.default)(ProductDetailSpagetty);

exports.default = _default;